module.exports = __webpack_public_path__ + "img/training_left.22a294af.png";